import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  actions: {
    create({ commit, dispatch }, model) {
      return ajax.post("Sales/api/Segments", model);
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Sales/api/Segments",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    update({ commit, dispatch }, model) {
      return ajax.put("Sales/api/Segments", model).then(() => {});
    },
    assignAgentSegment({ commit, dispatch }, model) {
      return ajax.put("Sales/api/SaleAgents/SegmentInfo", model);
    },
    unassignAgentSegment({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "Sales/api/SaleAgents/SegmentInfo",
            { data: model },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    assignProductInfo({ commit, dispatch }, model) {
      return ajax.put("Sales/api/Segments/ProductInfo", model);
    },
    unassignProductInfo({ commit, dispatch }, { segmentId, actualProductId }) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "Sales/api/Segments/ProductInfo",
            {
              data: { segmentId: segmentId, actualProductId: actualProductId },
            },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    getAllSegments({ commit, dispatch }) {
      return ajax
        .get("/Sales/api/SegmentQuery/all")
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return { success: false, error };
        });
    },
    searchSegmentByName({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/SegmentQuery/contains/" + name)
          .then((r) => {
            resolve(r.data.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    searchSegmentByItemCOde({ commit, dispatch }, ItemCode) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/SegmentQuery/" + ItemCode + "/segment-info")
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
  },
};
